<template>
    <div id="introduction">
        <HomeImages />
        <ShortIntro />
    </div>
</template>

<script>
import HomeImages from './HomeImages.vue'
import ShortIntro from './ShortIntro.vue'

export default {
    name:'Introduction',
    components: { HomeImages, ShortIntro }
}
</script>

<style scoped>
#introduction{
    height: 100vh;
    min-height: 600px;
    position: relative;
}
</style>